<div class="row guest-user-information">
  <div class="col-12">
    <h3 *appApplyIfNotEmpty="translationService.getTranslation('guestUser.informationHeadline')"
        [innerHTML]="translationService.getTranslation('guestUser.informationHeadline')"></h3>
  </div>
  <div class="col-12 guest-user-information__message" [innerHTML]="message"></div>
  <div class="col-12 guest-user-information__actions">
    <button
      class="guest-user-information__button-logout"
      mat-raised-button
      color="primary"
      (click)="logout()"
      [innerHTML]="translationService.getTranslation('logout')">
    </button>
  </div>
</div>
